<template>
  <div>
    <div id="map">
      <GmapMap
        :center = position
        :zoom="16"
        map-type-id="terrain"
        style="width: 100%; height: 700px"
      >
        <GmapMarker
          :position = position
        ></GmapMarker>
      </GmapMap>

    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      position: {lat: 48.5204525, lng: 21.690317}
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Map.vue